import { useEffect } from "react";

import {
    ConfluenceTemplatesUnifiedRelayPageTemplate,
    ConfluenceTemplatesUnifiedRelayPageTemplateProps
} from "@/templates/software/confluence/templates/confluence-templates-page/src/relay/contentful-relay/confluence-templates-unified-contentful-relay-page.template";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export type ConfluenceTemplateCategoryRelayPageProps =
    ConfluenceTemplatesUnifiedRelayPageTemplateProps;

export const ConfluenceTemplateCategoryRelayPage = ({
    queryRef
}: ConfluenceTemplateCategoryRelayPageProps) => {
    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdConfluenceTemplateLandingGate);
    }, []);

    return <ConfluenceTemplatesUnifiedRelayPageTemplate queryRef={queryRef} />;
};
